<template src='./Acordeon.html'>
</template>
<script>
  import { consultarFormulariosMomentosLlenos } from '../../apiService/request/CrudEncuentro.js'
  import { serverBus } from '../../main'
  import Icono from '../Icono/Icono'
  export default {
    name: 'ListExpansion',
    components: {Icono},
    data () {
      return {
        expandSingle: true,
        formulariosMomentosllenos:[]
      }
    },
    props: {
        InformacionMomentosEncuentro: {
            type: Array,
            required: true
        },
    },
    created() {
    },
    methods: {
        async consultarFormulariosMomentos(momento,index){
          this.$store.dispatch('setMomentoActual',index+1)
          this.formulariosMomentosllenos=[]
          const respuesta = await consultarFormulariosMomentosLlenos(this.$store.getters.getId,momento)
          this.formulariosMomentosllenos=respuesta.data.data
        },
        consultarFormulariosMomentosAcordeon(nombreCategoria){
          serverBus.$emit("verCategoriaFormularioAcordeon", nombreCategoria);  
        },
    },
  }
</script>
<style lang="scss" scoped src='./Acordeon.scss'>
</style>



// WEBPACK FOOTER //
// src/components/Acordeon/Acordeon.vue